  // Select all buttons with that class
  document.querySelectorAll('.openchatwindow').forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      $chatway.openChatwayWidget();
    });
  });

